import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = { class: "bv-card" };
const _hoisted_2 = { class: "bv-card__body" };
const _hoisted_3 = { class: "bv-card__facts" };
const _hoisted_4 = {
    key: 0,
    class: "bv-card__empty"
};
const _hoisted_5 = {
    key: 1,
    class: "bv-card__empty"
};
const _hoisted_6 = { class: "bv-card__group-label bv-card__label" };
const _hoisted_7 = { class: "bv-card__k" };
const _hoisted_8 = {
    key: 0,
    class: "bv-card__group"
};
const _hoisted_9 = { class: "bv-card__k" };
const _hoisted_10 = { class: "bv-card__side" };
const _hoisted_11 = { class: "bv-card__panel" };
const _hoisted_12 = {
    key: 0,
    class: "bv-card__score"
};
const _hoisted_13 = { class: "bv-card__score-head" };
const _hoisted_14 = { class: "bv-card__score-n" };
const _hoisted_15 = { class: "bv-card__score-track" };
const _hoisted_16 = { class: "bv-card__prov" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "bv-card__mono" };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = {
    key: 1,
    class: "bv-card__notes"
};
const _hoisted_22 = {
    key: 1,
    class: "bv-card__cta"
};
import { computed, toRef } from "vue";
import BenefitsVerificationDialog from "@/components/benefits/BenefitsVerificationDialog.vue";
import VoiceCallPanel from "@/components/voice_ai/VoiceCallPanel.vue";
import { useBenefitsVerification } from "@/composables/useBenefitsVerification";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BenefitsVerificationCard',
    props: {
        anchor: {},
        surface: { default: "QUALIFY_PATIENT" },
        patient: { default: null },
        prefill: { default: null },
        readonly: { type: Boolean, default: false },
        records: { default: undefined },
        recordsLoading: { type: Boolean, default: false },
        voice: { type: Boolean, default: true },
        config: { default: undefined },
        templates: { default: undefined },
        calls: { default: undefined },
        callsLoading: { type: Boolean, default: false }
    },
    emits: ["changed", "reload", "call-triggered"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { latest, loading, confirming, error, dialogOpen, status, headline, plan, money, services, provenance, load, confirm, onSaved, onCallsChanged, } = useBenefitsVerification(toRef(props, "anchor"), {
            external: () => props.records,
            onChanged: (record) => emit("changed", record),
            onReload: () => emit("reload"),
        });
        const groups = computed(() => [
            { label: "Eligibility", facts: headline.value },
            { label: "Cost sharing", facts: money.value },
            { label: "Plan", facts: plan.value },
        ].filter((group) => group.facts.length));
        const scoreClass = computed(() => {
            const score = provenance.value?.score ?? 0;
            if (score >= 80)
                return "bv-card__score-fill--good";
            return score >= 60 ? "bv-card__score-fill--mid" : "bv-card__score-fill--low";
        });
        function serviceLabel(service) {
            if (service.covered === false)
                return "Not covered";
            if (service.covered === true)
                return service.priorAuthRequired ? "Covered, PA required" : "Covered";
            return "";
        }
        function openDialog() {
            dialogOpen.value = true;
        }
        function serviceTone(service) {
            if (service.covered === false)
                return "bv-card__v--no";
            return service.covered === true ? "bv-card__v--yes" : "";
        }
        __expose({ reload: load });
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                (_unref(error))
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error",
                        variant: "tonal",
                        density: "compact",
                        class: "ma-3"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(error)), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bv-card__head" }, [
                            _createElementVNode("span", { class: "bv-card__title" }, "Benefit verification")
                        ], -1)),
                        ((_unref(loading) || __props.recordsLoading) && !_unref(latest))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading…"))
                            : (!_unref(latest))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (__props.readonly)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode("Nothing on file.")
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("Nothing on file yet. Enter what the payer told you.")
                                        ], 64))
                                ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: group.label,
                                            class: "bv-card__group"
                                        }, [
                                            _createElementVNode("div", _hoisted_6, _toDisplayString(group.label), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.facts, (fact) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: fact.key,
                                                    class: "bv-card__row"
                                                }, [
                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(fact.label), 1),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["bv-card__v", fact.tone ? `bv-card__v--${fact.tone}` : ''])
                                                    }, _toDisplayString(fact.value), 3)
                                                ]));
                                            }), 128))
                                        ]));
                                    }), 128)),
                                    (_unref(services).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bv-card__group-label bv-card__label" }, "Services", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service, i) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: `${service.name}-${i}`,
                                                    class: "bv-card__row"
                                                }, [
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(service.name), 1),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["bv-card__v", serviceTone(service)])
                                                    }, _toDisplayString(serviceLabel(service)), 3)
                                                ]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "bv-card__head" }, [
                            _createElementVNode("span", { class: "bv-card__title" }, "Verification")
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["bv-card__status", `bv-card__status--${_unref(status).key}`])
                            }, [
                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bv-card__dot" }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref(status).label), 1)
                            ], 2),
                            (_unref(provenance))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(provenance).score !== null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "bv-card__label" }, "Call confidence", -1)),
                                                _createElementVNode("span", _hoisted_14, [
                                                    _createTextVNode(_toDisplayString(_unref(provenance).score), 1),
                                                    _cache[5] || (_cache[5] = _createElementVNode("span", null, "/100", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["bv-card__score-fill", scoreClass.value]),
                                                    style: _normalizeStyle({ width: `${_unref(provenance).score}%` })
                                                }, null, 6)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("dl", _hoisted_16, [
                                        _createElementVNode("div", null, [
                                            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Source", -1)),
                                            _createElementVNode("dd", null, _toDisplayString(_unref(provenance).source), 1)
                                        ]),
                                        (_unref(provenance).rep)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Rep", -1)),
                                                _createElementVNode("dd", null, _toDisplayString(_unref(provenance).rep), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(provenance).reference)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Reference", -1)),
                                                _createElementVNode("dd", _hoisted_19, _toDisplayString(_unref(provenance).reference), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(provenance).verifiedAt)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Confirmed", -1)),
                                                _createElementVNode("dd", null, _toDisplayString(_unref(provenance).verifiedBy) + ", " + _toDisplayString(_unref(provenance).verifiedAt.toLocaleDateString()), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (_unref(provenance).notes)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_unref(provenance).notes), 1))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : _createCommentVNode("", true),
                            (!__props.readonly)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_unref(latest) && _unref(latest).status !== 'VERIFIED')
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            block: "",
                                            size: "small",
                                            rounded: "sm",
                                            variant: "flat",
                                            color: "primary",
                                            loading: _unref(confirming),
                                            onClick: _unref(confirm)
                                        }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createTextVNode(" Confirm benefits ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["loading", "onClick"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_v_btn, {
                                        block: "",
                                        size: "small",
                                        rounded: "sm",
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: openDialog
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(latest) ? "Edit" : "Enter manually"), 1)
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (__props.voice && !__props.readonly)
                            ? (_openBlock(), _createBlock(VoiceCallPanel, {
                                key: 0,
                                class: "bv-card__calls",
                                title: "Calls",
                                dense: "",
                                "trigger-label": "Place call",
                                "trigger-variant": "text",
                                anchor: __props.anchor,
                                surface: __props.surface,
                                patient: __props.patient,
                                config: __props.config,
                                templates: __props.templates,
                                calls: __props.calls,
                                "calls-loading": __props.callsLoading,
                                onCallTriggered: _cache[0] || (_cache[0] = ($event) => (emit('call-triggered', $event))),
                                onCallsChanged: _unref(onCallsChanged)
                            }, null, 8, ["anchor", "surface", "patient", "config", "templates", "calls", "calls-loading", "onCallsChanged"]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(BenefitsVerificationDialog, {
                    modelValue: _unref(dialogOpen),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(dialogOpen) ? (dialogOpen).value = $event : null)),
                    anchor: __props.anchor,
                    record: _unref(latest),
                    prefill: __props.prefill,
                    onSaved: _unref(onSaved)
                }, null, 8, ["modelValue", "anchor", "record", "prefill", "onSaved"])
            ]));
        };
    }
});
